export default "__VITE_ASSET__90c0e1ad__"